import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import historyReducer from "./history/history";
import applicationsReducer from "./applications/applications";
import customDataTypesReducer from "./custom-data-types/customDataTypes";
import connectedSystemsReducer from "./connected-systems/connectedSystem";
import recordTypesReducer from "./record-types/recordTypes";
import httpIntegrationsReducer from "./http-integration/httpIntegration";
import processesReducer from "./processes/processes";
import rulesReducer from "./rules/rules";
import foldersReducer from "./folders/folders";
import ProcessModelerReducer from "./Process-modular/processModular";
import NodeInputOutputReducer from "./node-io/nodeInputsOutputs";
import monitorReducer from "./monitor/monitor";
import administrationReducer from "./administration/administration";
import webApiReducer from "./web-api/web-api";
import chatReducer from "./chat/chat";

export const store = configureStore({
  reducer: combineReducers({
    applications: applicationsReducer,
    processes: processesReducer,
    rules: rulesReducer,
    customDataTypes: customDataTypesReducer,
    recordTypes: recordTypesReducer,
    connectedSystems: connectedSystemsReducer,
    httpIntegrations: httpIntegrationsReducer,
    folders: foldersReducer,
    processModeler: ProcessModelerReducer,
    webApi: webApiReducer,
    history: historyReducer,
    nodeIODetails: NodeInputOutputReducer,
    administration: administrationReducer,
    monitor: monitorReducer,
    chat: chatReducer,
  }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
